if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.countElement = this.button ? this.button.querySelector('.load-more__count') : null;
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
      this.totalLoaded = this.grid ? this.grid.querySelectorAll('.column').length : 0;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      if (search) {
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(
        function (entries) {
          if (entries[0].intersectionRatio === 1) {
            base.loadProducts();
          }
        },
        {
          threshold: [0, 1],
        }
      );
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.getAttribute('loading')) {
        return;
      }
      base.i++;
      base.setAttribute('loading', true);
      console.log(`Fetching products from: ${url}`);

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url,
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      let products = grid_to_replace ? grid_to_replace.querySelectorAll('.column') : [];

      console.log(`Products found: ${products.length}`);
      console.log(`Before appending, totalLoaded: ${base.totalLoaded}`);

      if (products.length === 0) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.setAttribute('disabled', 'true');
          base.button.style.display = 'none';
          document.querySelector('.viewed-all').classList.remove('tw-hidden');
        }
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      base.totalLoaded += products.length;
      console.log(`After appending, totalLoaded: ${base.totalLoaded}`);

      // Check if the next page contains products, and hide the button earlier if it's the last page
      let nextPageUrl = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      fetch(nextPageUrl)
        .then((response) => response.text())
        .then((nextHtml) => {
          let nextGrid = new DOMParser().parseFromString(nextHtml, 'text/html').getElementById('product-grid');
          let nextProducts = nextGrid ? nextGrid.querySelectorAll('.column') : [];
          if (nextProducts.length < 10) {
            base.updateCount(nextProducts.length);
          }
          if (nextProducts.length === 0 && base.button) {
            base.button.setAttribute('disabled', 'true');
            base.button.style.display = 'none';
            document.querySelector('.viewed-all').classList.remove('tw-hidden');
          }
        });

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30,
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          },
        });
      } else {
        base.removeAttribute('loading');
      }
    }
    updateCount(products) {
      if (this.countElement) {
        this.countElement.textContent = products;
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
